import {
  commitMutation,
  graphql
} from 'react-relay';
import environment from '../Environment';

const mutation = graphql`
mutation MakeDuplicataMutation($propositionId: String!) {
  makeDuplicata(propositionId: $propositionId) { 
    ok
    token
    error
  }
}
`;

export default ({ propositionId }, done) => {
  const variables = {
    propositionId
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      updater: () => {
      },
      optimisticUpdater: () => {
      },
      onCompleted: (response) => {
        const { ok, token, error } = response.makeDuplicata;
        done(ok, token, error);
      },
      onError: err => console.error(err)
    }
  );
};
